import React from 'react'
import AssetTransferList from '../../components/assettransfercomponents/AssetTransferList'

function AssetTransfer({renderPageContent}) {
    return (
       <>
       <AssetTransferList renderPageContent={renderPageContent}/>
       </>
    )
}

export default AssetTransfer
